<template>
  <component :is="template">
    <router-view />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const template = computed(
  () => `${String(route.meta.layout || 'public')}-layout`
)
</script>
